export default {
    async sleep(time) {
        return new Promise((resolve) => setTimeout(resolve, time));
    },
    async fetch(url) {
        // Fetch data from AniList API
        let res;
        try {
            res = await fetch(url);
        } catch (err) {
            // Retry if request fails
            console.error("Request failed, retrying in 60 seconds", res);
            console.error(err);

            await this.sleep(30000);

            return await this.fetch(url);
        }

        if (!res.ok) {
            // Retry if request fails
            console.warn("Request failed, retrying in 60 seconds", res);

            await this.sleep(30000);

            return await this.fetch(url);
        }

        return await res.json();
    },
    async fetchNoCooldown(url) {
        let res;
        try {
            res = await fetch(url, {
                signal: AbortSignal.timeout(10000),
            });
        } catch (err) {
            return null;
        }

        if (!res.ok) {
            return null;
        }

        return await res.json();
    },
}